import { IsDefined, IsString } from 'class-validator';

export class ChatChannelDto {
  @IsDefined()
  @IsString()
  name: string;

  @IsDefined()
  @IsString()
  id: string;

  @IsDefined()
  @IsString()
  cid: string;
}
